import Vue from 'vue'
import gql from 'graphql-tag'
import { apolloClient } from '@/apollo'

const getAllNewMarketplace = gql`
  query getAllNewMarketplace($limit: Int, $offset: Int) {
    news_marketplace_aggregate {
      aggregate {
        count
      }
    }
    news_marketplace(order_by: {published_at: asc}, limit: $limit, offset: $offset) {
      created_at,
      id,
      title,
      is_active,
      published_at,
      updated_at
      news_translations_marketplaces(distinct_on:id) {
        content,
        id,
        language_code,
        news_marketplace_id,
      }
    }
  }
`

const createNewsMarketplaceGql = gql`
  mutation createNewsMarketplaceGql($newsData: news_marketplace_insert_input!) {
    insert_news_marketplace(objects: [$newsData]) {
      affected_rows
      returning {
        id
      }
    }
  }
`

const updateNewsMarketplaceGql = gql`
  mutation updateNewsMarketplaceAndTranslations(
  $newsId: uuid!,
  $isActive: Boolean!,
  $publishedAt: date!,
  $updatehedAt: date!,
  $translationEnContent: String!,
  $translationEsContent: String!
) {
  # Actualizar el registro principal de news_marketplace
  update_news_marketplace(
    where: { id: { _eq: $newsId } },
    _set: { is_active: $isActive, published_at: $publishedAt, updated_at: $updatehedAt }
  ) {
    returning {
      id
      is_active
      published_at
    }
  }

  update_translation_en: update_news_translations_marketplace(
    where: {
      news_marketplace_id: { _eq: $newsId },
      language_code: { _eq: "en" }
    },
    _set: { content: $translationEnContent }
  ) {
    returning {
      id
      language_code
      content
    }
  }

  update_translation_es: update_news_translations_marketplace(
    where: {
      news_marketplace_id: { _eq: $newsId },
      language_code: { _eq: "es" }
    },
    _set: { content: $translationEsContent }
  ) {
    returning {
      id
      language_code
      content
    }
  }
}

`

const newsMarketplace = {
  namespaced: true,
  state: {
    newsMarketplace: []
  },
  actions: {
    async createNewsMarketplace ({ dispatch }, variables) {
      try {
        const response = await apolloClient.mutate({
          mutation: createNewsMarketplaceGql,
          variables
        })
        if (response && response.data && response.data) {
          dispatch('fetchAllNews')
          return response.data
        }
        throw new Error('Error al crear las noticias')
      } catch (error) {
        console.error(error)
        throw new Error(error)
      }
    },
    async updateNewsMarketplace ({ dispatch }, variables) {
      try {
        const response = await apolloClient.mutate({
          mutation: updateNewsMarketplaceGql,
          variables
        })
        if (response && response.data && response.data) {
          dispatch('fetchAllNews')
          return response.data
        }
        throw new Error('Error al actualizar las noticias')
      } catch (error) {
        console.error(error)
        throw new Error(error)
      }
    },
    async fetchAllNews ({ state }, variables) {
      try {
        const response = await apolloClient.query({
          fetchPolicy: 'network-only',
          query: getAllNewMarketplace,
          variables
        })

        if (response && response.data && response.data.news_marketplace) {
          Vue.set(state, 'newsMarketplace', response.data.news_marketplace)
          return response.data
        }
      } catch (error) {
        console.error(error)
        return error
      }
    }
  }
}

export default newsMarketplace



// WEBPACK FOOTER //
// ./src/store/modules/newsMarketplace.js